import { render, staticRenderFns } from "./slist.vue?vue&type=template&id=2edc6912"
import script from "./slist.vue?vue&type=script&lang=js"
export * from "./slist.vue?vue&type=script&lang=js"
import style0 from "./slist.vue?vue&type=style&index=0&id=2edc6912&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports